<template>
  <div class="LayoutHeader" ref="LayoutHeader">
    <div class="LayoutHeader-cont">
      <div class="header-left">
        <img class="logo" alt="千里马招标信息" @click="handleLogo" src="../../assets/img/header/logo.svg" />
      </div>
      <div class="LibHeaderInput-box">
        <div class="LibHeaderInput">
          <i class="iconfont icon-sousuo sosuoIconfont"></i>
          <el-input
            v-model="keyWord"
            placeholder="请输入您要搜索的内容"
            maxlength="100"
            @keyup.enter.native="handleSearch"
          ></el-input>
          <el-button class="HeaderInputButton" type="primary" round @click="handleSearch"> 搜索</el-button>
        </div>
        <div class="search-hot">
          <img src="../../assets/img/header/search-hot.png" alt="" />
          <template v-for="(item, index) in hotList">
            <a :key="index" :href="getHrefUrl(item)" class="a-link" target="_blank">
              <span>{{ item }}</span
              ><em v-if="index !== hotList.length - 1">|</em>
            </a>
          </template>
        </div>
      </div>
      <div class="header-right">
        <p>
          <ProductsServicesButtonModule />
          <em>|</em>
        </p>
        <!--产品服务-->
        <p>
          <span
            class="enterprise-package"
            v-track
            :data-oid="OID_MAP.ENTERPRISE_PACKAGE_CLICK"
            @click="goToUrl(ENTERPRISE_PACKAGE)"
          >
            企业套餐
          </span>
        </p>
        <template>
          <div v-if="isLogin" class="avatar">
            <el-avatar :src="require(`../../assets/img/default_avatar${userInfo.sex === 'f' ? '_f' : ''}.png`)"></el-avatar>
            <div class="avatar-box">
              <div class="user_info">
                <div class="left">
                  <img
                    class="avatar"
                    :src="require(`../../assets/img/default_avatar${userInfo.sex === 'f' ? '_f' : ''}.png`)"
                    alt="default_avatar"
                    width="46"
                    height="46"
                  />
                </div>
                <div class="right">
                  <div class="right_top">
                    <div class="nickname" :title="userInfo.linkName">
                      {{ userInfo.linkName || "未命名" }}
                    </div>
                  </div>
                  <div class="right_bottom">
                    <div class="companyName" :title="userInfo.companyName">
                      {{ userInfo.companyName || "未填写公司名称" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="member">
                <div class="left">
                  <div class="left_top">{{ userInfo.memberLevelName }}</div>
                  <div class="left_bottom">
                    <span class="area" :title="userInfo.areaName">{{ userInfo.areaName }}</span>
                  </div>
                </div>
              </div>
              <div class="cell no-hover">
                <span>{{ userInfo.username }}</span
                ><span class="tip">用户名</span>
              </div>
              <div class="cell" @click="handleUserInfoClick">
                <span>账号信息</span>
              </div>
              <div class="cell" @click="handleCenter">
                <span>会员中心</span>
              </div>
              <div class="logout">
                <div class="cell" @click="handleLoginOut">
                  <span>退出登录</span>
                </div>
              </div>
            </div>
          </div>
          <el-button v-if="!isLogin" size="medium" type="primary" round @click="showLoginDialog"> 登录/注册 </el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ABOUT_US,
  CUSTOM_USER_CENTER_URL,
  ENTERPRISE_PACKAGE,
  OLD_HOME_ZHAOBIAO,
  OLD_USER_CENTER_URL,
  PUBLIC_PATH,
  OLD_SEARCH_PAGE_URL,
  SEARCH_PAGE_URL,
  ACCOUNT_INFORMATION
} from "../../utils/constants/constants";
import ProductsServicesButtonModule from "../LibLayoutHeader/ProductServicesButtonModule";
import { clearCookies, getServicePhone, isValEmpty } from "../../utils/common";
import { commonCusApiHomepageIdTypeGw, restUserApiHomepageLogout } from "../../services/home";
import { OID_MAP } from "../../utils/constants/constants.track";

export default {
  name: "LayoutHeaderSearchCenter",
  components: { ProductsServicesButtonModule },
  props: {
    loginSuccessGoData: {
      type: Object,
      default: () => {
        return {
          type: "open",
          url: OLD_USER_CENTER_URL,
        };
      },
    },
  },
  data() {
    return {
      OID_MAP,
      ENTERPRISE_PACKAGE,
      ABOUT_US,
      OLD_HOME_ZHAOBIAO,
      toFixed: false,
      isEjected: "",
      scrollTop: 0,
      isShowCustomUserCenter: false,
      keyWord: "",
      hotList: ["医疗", "智慧城市", "银行", "物业", "碳中和", "政府采购", "建筑"],
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    isShowDialogLogin() {
      return this.$store.getters["basic/isShowDialogLogin"];
    },
    loginSuccessGo() {
      return this.$store.getters["basic/loginSuccessGo"];
    },
    isLogin() {
      return this.$store.getters["basic/isLogin"];
    },
  },
  methods: {
    servicePhone() {
      return getServicePhone(this.$store.getters["basic/isPayBefore"]);
    },
    showLoginDialog() {
      this.$store.commit("basic/updateIsShowDialogLogin", true);
      this.$store.commit("basic/updateLoginSuccessGo", this.loginSuccessGoData);
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    closeDialog() {
      this.$store.commit("basic/updateIsShowDialogLogin", false);
    },
    handleCenter() {
      window.open(OLD_USER_CENTER_URL);
    },
    handleLogo() {
      window.location.href = PUBLIC_PATH;
    },
    handleLoginOut() {
      this.$confirm("您确定要退出登录？", "提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        lockScroll: false,
      })
        .then(async () => {
          try {
            await restUserApiHomepageLogout();
            this.$message({
              message: "您已退出",
              type: "info",
              onClose: () => {
                this.redirectToLoginPage();
              },
            });
          } catch (e) {
            this.$message({
              message: "退出失败，稍后重试",
              type: "error",
              onClose: () => {},
            });
          }
        })
        .catch(() => {});
    },
    // 跳转至登录页
    redirectToLoginPage() {
      // 清除cookies
      clearCookies();
      window.location.replace(PUBLIC_PATH);
    },
    goToUrl(path) {
      window.open(path);
    },
    async init() {
      if (this.isLogin) {
        const res = await commonCusApiHomepageIdTypeGw({ id: this.userInfo.userId });
        // type > 0 展示 --- 李雷鹏
        this.isShowCustomUserCenter = res.data.type > 0;
      }
    },
    toCustomUserCenter() {
      window.location.href = CUSTOM_USER_CENTER_URL;
    },
    handleSearch() {
      const keywordParam = this.isLogin ? "keyword" : "q";

      window.open(
        `${this.isLogin ? SEARCH_PAGE_URL : OLD_SEARCH_PAGE_URL}?${keywordParam}=${encodeURIComponent(this.keyWord)}`
      );
      if (this.isLogin) {
        location.reload();
      }
    },
    getHrefUrl(item) {
      const keywordParam = this.isLogin ? "keyword" : "q";
      return `${this.isLogin ? SEARCH_PAGE_URL : OLD_SEARCH_PAGE_URL}?${keywordParam}=${encodeURIComponent(item)}`;
    },
    handleUserInfoClick() {
      window.location.href = ACCOUNT_INFORMATION;
    },

   
   
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
};
</script>
<style scoped lang="scss">
@import "../../assets/config";

.LayoutHeader {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 10px 0px rgba(114, 116, 121, 0.13);
  backdrop-filter: blur(15px);
  min-width: $layout-body-width;

  .LayoutHeader-cont {
    width: $layout-body-width;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .header-left {
    display: flex;
    align-items: center;
    float: left;
    .logo {
      cursor: pointer;
      width: 108px;
    }

    .custom-user-center {
      margin-left: 26px;
      cursor: pointer;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    float: right;
    padding-bottom: 12px;
    & > p {
      margin-right: 26px;
      display: flex;
      align-items: center;
      a {
        &:hover {
          color: $theme-color;
          font-weight: $font-weight-Medium;
        }
      }
    }
    em {
      font-style: normal;
      position: relative;
      left: 9px;
      color: #e1e6ea;
    }
    .phone {
      color: #2a2b33;
      font-weight: $font-weight-Medium;
      display: flex;
      align-items: center;

      .iconfont {
        padding-right: 4px;
        color: #a3a6ab;
      }
    }

    .enterprise-package {
      padding-left: 24px;
      color: #be851d;
      background: url("../../assets/img/header/enterprise-package.png") no-repeat;
      background-size: 22px 22px;
      cursor: pointer;

      &:hover {
        color: #eba31f;
        font-weight: $font-weight-Medium;
      }
    }

    .el-button {
      width: 95px;
      font-weight: 550;

      &:hover {
        background: #f66d59;
        border-color: #f66d59;
      }
    }

    .login-but {
      background: rgba(0, 0, 0, 0);
      border-color: $theme-color;
      color: $theme-color;

      &:hover {
        background: rgba(0, 0, 0, 0);
        border-color: #f66d59;
        color: #f66d59;
      }
    }

    .userInfo {
      background: url("../../assets/img/header/avator.png") no-repeat;
      background-size: 22px 22px;
      background-position-x: left;
      background-position-y: center;
      padding-left: 24px;
    }

    .loginOut {
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
    }
  }
  .LibHeaderInput-box {
    flex: 1;
    position: relative;
    padding-left: 70px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: 24px;
  }
  .search-hot {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #797c81;
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 12px;
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #797c81;

      span:hover {
        color: $theme-color;
      }
    }

    img {
      width: 42px;
      height: 18px;
      margin-right: 10px;
    }

    span {
      display: block;
      padding: 0 8px;
      line-height: 17px;
    }

    em {
      font-style: normal;
      line-height: 17px;
      color: #dddddd;
    }
  }
  .LibHeaderInput {
    width: 560px;
    background: #fff;
    border: 1px solid #df6250;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding-left: 18px;
    min-width: 120px;
    position: relative;

    .sosuoIconfont {
      color: #a2a6ac;
      font-size: 14px;
    }
    .el-input {
      ::v-deep .el-input__inner {
        border: 0;
        font-size: 14px;
        height: 34px;
        padding-left: 7px;
        padding-right: 28px;
        border-radius: 31px;
        background: #fff;
      }
    }

    .HeaderInputButton {
      position: absolute;
      height: 36px;
      top: -1px;
      right: -3px;
      border-radius: 0 30px 30px 0;
      padding-top: 10px;
      width: 79px;
      &:hover {
        background: #f66d59;
        border-color: #f66d59;
      }
    }
  }
  .avatar {
    position: relative;
    &:hover{
      .avatar-box {
        display: block;
      }
    }
    .avatar-box {
      position: absolute;
      top: 45px;
      right: 0;
      width: 300px;
      background: #fff;
      z-index: 22;
      display: none;
      border-radius: 4px;
box-shadow: 0px 4px 10px 0px rgba(8,21,78,0.07); 
    }
    .user_info {
      width: 100%;
      height: 90px;
      background: url("../../assets/img/bg-popup-user.png") center center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 20px;
      color: white;

      .left {
        display: flex;

        .avatar {
        }
      }

      .right {
        margin-left: 8px;

        .right_top {
          display: flex;
          align-items: center;

          .nickname {
            max-width: 108px;

            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 600;
            color: #ffffff;
            line-height: 25px;

            //单行
            word-break: break-all;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .label {
            width: 82px;
            height: fit-content;
            background-color: #ffcec6;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 9px;

            font-size: 12px;
            font-family: NotoSansCJKsc, NotoSansCJKsc-Regular;
            font-weight: 400;
            color: #bc8600;
            line-height: 18px;
            letter-spacing: -0.61px;

            margin-left: 6px;
            cursor: pointer;

            img {
              width: 13px;
              height: 13px;
              margin-right: 1px;
              margin-left: -2px;
            }
          }
        }

        .right_bottom {
          margin-top: 9px;

          .companyName {
            max-width: 210px;

            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;

            //单行
            word-break: break-all;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }
      }
    }

    .member {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 6px 18px 20px;
      border-bottom: 1px #e8e8e8 solid;
      margin-bottom: 8px;

      .left {
        .left_top {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #333333;
          line-height: 22px;
        }

        .left_bottom {
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
          margin-top: 8px;
          display: flex;

          .area {
            //单行
            word-break: break-all;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .expire_date {
            flex-shrink: 0;
          }
        }
      }

      .right {
        display: flex;
        cursor: pointer;

        img {
          width: 82px;
          object-fit: contain;
        }
      }
    }

    .cell {
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 20px;

      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 20px;

      cursor: pointer;

      &:hover {
        background-color: rgba(223, 98, 80, 0.04);
      }

      .tip {
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }

    .no-hover {
      cursor: text;

      &:hover {
        background-color: white;
      }
    }

    .logout {
      margin-top: 8px;
      border-top: 1px #e8e8e8 solid;
      padding: 8px 0;
    }
  }
}
</style>
